import React from 'react';
import { Link } from 'react-router-dom';
import { SOCIAL_LINKS } from '../../config';
import { getFooterLink } from '../../utils';
import ImageElement from '../UIElements/ImageElement';
import { accessRoute as customerRoutes } from '../../routes/CustomerApp/terms';

import { accessRoute } from '../../routes/Auth/store';
import { customerLink, getSocialMediaLinks } from '../../redux/index.redux';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { accessRoute as storeRoutes } from '../../routes/Auth/store';

function StoreFooter({ routes, isStore }) {
  const FooterData = getFooterLink(routes);

  const GeneralPathLinks = [{ ...customerRoutes }];

  const socialMediaLinks = useSelector(getSocialMediaLinks);
  const dispatch = useDispatch();

  const WindowOpen = (Links) => {
    window.open(Links);
  };

  const handleData = (type) => {
    socialMediaLinks?.rows?.find(
      (item) => item?.key === type && WindowOpen(item?.value)
    );
  };

  useEffect(() => {
    dispatch(customerLink());
  }, []);

  return (
    <footer className="footer">
      <div className="footer_top  position-relative">
        <div className="container">
          <div className="wrap mx-auto position-relative">
            <h2 className="font-md text-white ">
              Check out our mobile app & experience the{' '}
              <span className="position-relative">fastest</span> home services
            </h2>
            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleData('android_app_website_footer');
                }}
                className="me-2"
              >
                <ImageElement
                  source="google-play.svg"
                  alt="Google-play"
                  className="img-fluid"
                />
              </Link>
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleData('iphone_app_website_footer');
                }}
              >
                <ImageElement
                  source="app-store.svg"
                  alt="App-store"
                  className="img-fluid"
                />
              </Link>
            </div>
            <ImageElement
              source="footer-img.png"
              className="wrap_img"
              alt="footer-img"
            />
          </div>
        </div>
      </div>
      <div className="footer_main">
        <div className="footer_main_top">
          <div className="container">
            <div className="d-flex justify-content-between flex-wrap">
              <div className="footer_main_cstm text-center text-sm-start">
                <div className="ftLftInfo">
                  <Link to="/">
                    <ImageElement source="logo-white.svg" alt="logo" />
                  </Link>
                  <p className="text-white">
                    Need help finding a Professional?
                  </p>
                  <ul className="list-unstyled mb-0">
                    {console.log("SOCIAL_LINKS.MAIL" , SOCIAL_LINKS.MAIL)}
                    <li>
                      <a href={SOCIAL_LINKS.MAIL}>
                        <em className="gg-message"></em>{' '}
                        {SOCIAL_LINKS.FOOTER_MAIL}
                      </a>
                    </li>
                    <li>
                      <a href={SOCIAL_LINKS.PHONE}>
                        <em className="gg-Calling"></em>{' '}
                        {SOCIAL_LINKS.FOOTER_PHONE}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="footer_main_cstm">
                <div className="ftMenu">
                  <h3 className="font-md text-white">General Links</h3>
                  {GeneralPathLinks.map((routes, index) => (
                    <ul key={index} className="list-unstyled mb-0">
                      <li key={index}>
                        <Link
                          to={
                            isStore
                              ? storeRoutes['ABOUT_US']?.path
                              : routes['ABOUT_US']?.path
                          }
                        >
                          {routes['ABOUT_US']?.name}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={
                            isStore
                              ? storeRoutes['HOW_IT_WORKS']?.path
                              : routes['HOW_IT_WORK']?.path
                          }
                        >
                          {routes['HOW_IT_WORK']?.name}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={
                            isStore
                              ? storeRoutes['FAQ']?.path
                              : routes['FAQS']?.path
                          }
                        >
                          {routes['FAQS']?.name}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={
                            isStore
                              ? storeRoutes['CONTACT_US']?.path
                              : routes['CONTACT_US']?.path
                          }
                        >
                          {routes['CONTACT_US']?.name}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={
                            isStore
                              ? storeRoutes['PRIVACY']?.path
                              : routes['PRIVACY']?.path
                          }
                        >
                          {routes['PRIVACY']?.name}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={
                            isStore
                              ? storeRoutes['TERMS']?.path
                              : routes['TERMS']?.path
                          }
                        >
                          {routes['TERMS']?.name}
                        </Link>
                      </li>
                    </ul>
                  ))}
                </div>
              </div>
              <div className="footer_main_cstm">
                {FooterData.map((item, key) => {
                  return (
                    <div className="ftMenu" key={key}>
                      <h3 className="font-md text-white">{item.label}</h3>
                      <ul className="list-unstyled mb-0">
                        {item.children.map((childData, childKey) => {
                          return (
                            <li key={childKey}>
                              <Link to={`${childData.path}`}>
                                {childData.label}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  );
                })}
              </div>

              <div className="footer_main_cstm">
                <div className="ftMenu">
                  <h3 className="font-md text-white">
                    Become a Good Guys Service Provider
                  </h3>
                  <ul className="list-unstyled mb-0">
                    <li>
                      <Link
                        to="#"
                        onClick={() =>
                          WindowOpen(
                            'https://www.goodguyshomeservices.com/serviceproviders/index.php/techpartner/'
                          )
                        }
                      >
                        Technician{' '}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() =>
                          WindowOpen(
                            'https://www.goodguyshomeservices.com/serviceproviders/index.php/companypartner/'
                          )
                        }
                      >
                        Existing Company
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="ftMenu">
                  <h3 className="font-md text-white">
                    Become an Affiliate for Good Guys
                  </h3>
                  <ul className="list-unstyled mb-0">
                    <li>
                      <Link to={accessRoute.STORE_SIGNUP.path}>
                        Become a Super Fan{' '}
                      </Link>
                    </li>
                    <li>
                      <Link to={accessRoute.STORE_LOGIN.path}>
                        Become a Referral Partner
                      </Link>
                    </li>
                    <li>
                      <Link to={accessRoute.STORE_LOGIN.path}>
                        Affiliate Login{' '}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer_main_cstm">
                {/* <div className="newsLetter">
                  <h3 className="text-white mb-xl-4 mb-2">Newsletter</h3>
                  <div className="newsLetter_field position-relative">
                    <input type="text" placeholder="Email Address" />
                    <Button variant="primary">Submit</Button>
                  </div>
                </div> */}
                <div className="d-flex align-items-center justify-content-center justify-content-md-start">
                  <div className="me-2">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleData('android_app_website_footer');
                      }}
                      className="me-2"
                    >
                      <ImageElement
                        source="google-play.svg"
                        alt="Google-play"
                        className="img-fluid"
                      />
                    </Link>
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleData('iphone_app_website_footer');
                      }}
                    >
                      <ImageElement
                        source="app-store.svg"
                        alt="App-store"
                        className="img-fluid"
                      />
                    </Link>
                  </div>
                </div>
                <div className="joinUs text-center text-sm-start">
                  <h5 className="text-white">Join us on</h5>
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleData('twitter_link');
                        }}
                      >
                        <em className="gg-twitter"></em>
                      </Link>
                    </li>
                    <li
                      className="list-inline-item"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleData('faceBook_link');
                        }}
                      >
                        <em className="gg-facebook"></em>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleData('linkedIn_link');
                        }}
                      >
                        <em className="gg-linkedin"></em>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleData('google_link');
                        }}
                      >
                        <em className="gg-google"></em>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleData('instagram_link');
                        }}
                      >
                        <em className="gg-instagram"></em>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer_main_bottom">
          <div className="container wrap text-white text-center">
            © Copyright 2023 Good Guys Home Services
          </div>
        </div>
      </div>
    </footer>
  );
}

export default StoreFooter;
